export const actualLaneData = (levelId, index, solutionAlias) => {

  const level = 'level' + levelId
  index = index + 1
  const data = {
    level3: {
      '100 bp DNA marker (M)': {
        colId: index,
        colType: "LADDER_COLUMN",
        colItems: [
          {
            cellId: 0,
            cellType: "LABEL_CELL",
            label: "DNA ladder",
          },
          {
            cellId: 1,
            cellType: "GEL_HOLDER",
            cellItems: [],
          },
          {
            cellId: 2,
            cellType: "GEL_PATH",
            cellItems: [
              {
                gelId: 0,
                gelType: "FIXED",
                height: 100,
                opacity: 0.9,
                value: 1000,
                selected: false,
              },
              {
                gelId: 1,
                gelType: "FIXED",
                height: 60,
                opacity: 0.8,
                value: 800,
                selected: false,
              },
              {
                gelId: 2,
                gelType: "FIXED",
                height: 60,
                opacity: 0.5,
                value: 700,
                selected: false,
              },
              {
                gelId: 3,
                gelType: "FIXED",
                height: 100,
                opacity: 0.9,
                value: 500,
                selected: false,
              },
              {
                gelId: 4,
                gelType: "FIXED",
                height: 60,
                opacity: 0.5,
                value: 400,
                selected: false,
              },
              {
                gelId: 5,
                gelType: "FIXED",
                height: 60,
                opacity: 0.4,
                value: 300,
                selected: false,
              },
              {
                gelId: 6,
                gelType: "FIXED",
                height: 60,
                opacity: 0.4,
                value: 200,
                selected: false,
              },
              {
                gelId: 7,
                gelType: "FIXED",
                height: 60,
                opacity: 0.3,
                value: 100,
                selected: false,
              },
            ],
          },
        ],
      },
      'PCR 1+': {
        "colId": index,
        "colType": "BAND_COLUMN",
        "colItems": [
          {
            "cellId": 0,
            "cellType": "LABEL_CELL",
            "label": solutionAlias
          },
          {
            "cellId": 1,
            "cellType": "GEL_HOLDER",
            "cellItems": []
          },
          {
            "cellId": 2,
            "cellType": "GEL_PATH",
            "cellItems": [
              {
                "gelId": 0,
                "gelType": "DRAGGABLE",
                "height": 100,
                "opacity": 0.8,
                "value": 250,
                "selected": false
              },
              {
                "gelId": 1,
                "gelType": "DRAGGABLE",
                "height": 80,
                "opacity": 0.5,
                "value": 150,
                "selected": false
              },
              {
                "gelId": 2,
                "gelType": "DRAGGABLE",
                "height": 80,
                "opacity": 0.5,
                "value": 90,
                "selected": false
              }
            ]
          }
        ]
      },
      'PCR 2+': {
        "colId": index,
        "colType": "BAND_COLUMN",
        "colItems": [
          {
            "cellId": 0,
            "cellType": "LABEL_CELL",
            "label": solutionAlias
          },
          {
            "cellId": 1,
            "cellType": "GEL_HOLDER",
            "cellItems": []
          },
          {
            "cellId": 2,
            "cellType": "GEL_PATH",
            "cellItems": [
              {
                "gelId": 0,
                "gelType": "DRAGGABLE",
                "height": 80,
                "opacity": 0.8,
                "value": 150,
                "selected": false
              },
              {
                "gelId": 1,
                "gelType": "DRAGGABLE",
                "height": 80,
                "opacity": 0.8,
                "value": 90,
                "selected": false
              }
            ]
          }
        ]
      },
      'PCR 3+': {
        "colId": index,
        "colType": "BAND_COLUMN",
        "colItems": [
          {
            "cellId": 0,
            "cellType": "LABEL_CELL",
            "label": solutionAlias
          },
          {
            "cellId": 1,
            "cellType": "GEL_HOLDER",
            "cellItems": []
          },
          {
            "cellId": 2,
            "cellType": "GEL_PATH",
            "cellItems": [
              {
                "gelId": 0,
                "gelType": "DRAGGABLE",
                "height": 100,
                "opacity": 1,
                "value": 250,
                "selected": false
              }
            ]
          }
        ]
      },
      'PCR 4+': {
        "colId": index,
        "colType": "BAND_COLUMN",
        "colItems": [
          {
            "cellId": 0,
            "cellType": "LABEL_CELL",
            "label": solutionAlias
          },
          {
            "cellId": 1,
            "cellType": "GEL_HOLDER",
            "cellItems": []
          },
          {
            "cellId": 2,
            "cellType": "GEL_PATH",
            "cellItems": [
              {
                "gelId": 0,
                "gelType": "DRAGGABLE",
                "height": 100,
                "opacity": 1,
                "value": 250,
                "selected": false
              }
            ]
          }
        ]
      },
      'PCR 5+': {
        "colId": index,
        "colType": "BAND_COLUMN",
        "colItems": [
          {
            "cellId": 0,
            "cellType": "LABEL_CELL",
            "label": solutionAlias
          },
          {
            "cellId": 1,
            "cellType": "GEL_HOLDER",
            "cellItems": []
          },
          {
            "cellId": 2,
            "cellType": "GEL_PATH",
            "cellItems": [
              {
                "gelId": 0,
                "gelType": "DRAGGABLE",
                "height": 80,
                "opacity": 0.8,
                "value": 150,
                "selected": false
              },
              {
                "gelId": 1,
                "gelType": "DRAGGABLE",
                "height": 80,
                "opacity": 0.8,
                "value": 90,
                "selected": false
              }
            ]
          }
        ]
      }
    },


    level2: {
      '100 bp DNA marker (M)': {
        "colId": index,
        "colType": "LADDER_COLUMN",
        "colItems": [
          {
            "cellId": 0,
            "cellType": "LABEL_CELL",
            "label": "DNA ladder"
          },
          {
            "cellId": 1,
            "cellType": "GEL_HOLDER",
            "cellItems": []
          },
          {
            "cellId": 2,
            "cellType": "GEL_PATH",
            "cellItems": [
              {
                "gelId": 0,
                "gelType": "FIXED",
                "height": 100,
                "opacity": 0.9,
                "value": 1000,
                "selected": false
              },
              {
                "gelId": 1,
                "gelType": "FIXED",
                "height": 60,
                "opacity": 0.8,
                "value": 800,
                "selected": false
              },
              {
                "gelId": 2,
                "gelType": "FIXED",
                "height": 60,
                "opacity": 0.5,
                "value": 700,
                "selected": false
              },
              {
                "gelId": 3,
                "gelType": "FIXED",
                "height": 100,
                "opacity": 0.9,
                "value": 500,
                "selected": false
              },
              {
                "gelId": 4,
                "gelType": "FIXED",
                "height": 60,
                "opacity": 0.5,
                "value": 400,
                "selected": false
              },
              {
                "gelId": 5,
                "gelType": "FIXED",
                "height": 60,
                "opacity": 0.4,
                "value": 300,
                "selected": false
              },
              {
                "gelId": 6,
                "gelType": "FIXED",
                "height": 60,
                "opacity": 0.4,
                "value": 200,
                "selected": false
              },
              {
                "gelId": 7,
                "gelType": "FIXED",
                "height": 60,
                "opacity": 0.3,
                "value": 100,
                "selected": false
              }
            ]
          }
        ]
      },
      "A": {
        "colId": index,
        "colType": "BAND_COLUMN",
        "colItems": [
          {
            "cellId": 0,
            "cellType": "LABEL_CELL",
            "label": "A"
          },
          {
            "cellId": 1,
            "cellType": "GEL_HOLDER",
            "cellItems": []
          },
          {
            "cellId": 2,
            "cellType": "GEL_PATH",
            "cellItems": [
              {
                "gelId": 0,
                "gelType": "DRAGGABLE",
                "height": 100,
                "opacity": 1,
                "value": 250,
                "selected": false
              },
              {
                "gelId": 0,
                "gelType": "DRAGGABLE",
                "height": 80,
                "opacity": 0.2,
                "value": 80,
                "selected": false
              }
            ]
          }
        ]
      },
      "A+": {
        "colId": index,
        "colType": "BAND_COLUMN",
        "colItems": [
          {
            "cellId": 0,
            "cellType": "LABEL_CELL",
            "label": "A+"
          },
          {
            "cellId": 1,
            "cellType": "GEL_HOLDER",
            "cellItems": []
          },
          {
            "cellId": 2,
            "cellType": "GEL_PATH",
            "cellItems": [
              {
                "gelId": 0,
                "gelType": "DRAGGABLE",
                "height": 100,
                "opacity": 1,
                "value": 250,
                "selected": false
              },
              {
                "gelId": 1,
                "gelType": "DRAGGABLE",
                "height": 80,
                "opacity": 0.2,
                "value": 80,
                "selected": false
              }
            ]
          }
        ]
      },
      "J": {
        "colId": index,
        "colType": "BAND_COLUMN",
        "colItems": [
          {
            "cellId": 0,
            "cellType": "LABEL_CELL",
            "label": "J"
          },
          {
            "cellId": 1,
            "cellType": "GEL_HOLDER",
            "cellItems": []
          },
          {
            "cellId": 2,
            "cellType": "GEL_PATH",
            "cellItems": [
              {
                "gelId": 0,
                "gelType": "DRAGGABLE",
                "height": 100,
                "opacity": 1,
                "value": 250,
                "selected": false
              },
              {
                "gelId": 1,
                "gelType": "DRAGGABLE",
                "height": 80,
                "opacity": 0.2,
                "value": 80,
                "selected": false
              }
            ]
          }
        ]
      },
      "J+": {
        "colId": index,
        "colType": "BAND_COLUMN",
        "colItems": [
          {
            "cellId": 0,
            "cellType": "LABEL_CELL",
            "label": "J+"
          },
          {
            "cellId": 1,
            "cellType": "GEL_HOLDER",
            "cellItems": []
          },
          {
            "cellId": 2,
            "cellType": "GEL_PATH",
            "cellItems": [
              {
                "gelId": 0,
                "gelType": "DRAGGABLE",
                "height": 80,
                "opacity": 0.8,
                "value": 150,
                "selected": false
              },
              {
                "gelId": 1,
                "gelType": "DRAGGABLE",
                "height": 80,
                "opacity": 0.8,
                "value": 90,
                "selected": false
              },
              {
                "gelId": 2,
                "gelType": "DRAGGABLE",
                "height": 80,
                "opacity": 0.2,
                "value": 80,
                "selected": false
              }
            ]
          }
        ]
      },
      "L": {
        "colId": index,
        "colType": "BAND_COLUMN",
        "colItems": [
          {
            "cellId": 0,
            "cellType": "LABEL_CELL",
            "label": "L"
          },
          {
            "cellId": 1,
            "cellType": "GEL_HOLDER",
            "cellItems": []
          },
          {
            "cellId": 2,
            "cellType": "GEL_PATH",
            "cellItems": [
              {
                "gelId": 0,
                "gelType": "DRAGGABLE",
                "height": 100,
                "opacity": 1,
                "value": 250,
                "selected": false
              },
              {
                "gelId": 1,
                "gelType": "DRAGGABLE",
                "height": 80,
                "opacity": 0.2,
                "value": 80,
                "selected": false
              }
            ]
          }
        ]
      },
      "L+": {
        "colId": index,
        "colType": "BAND_COLUMN",
        "colItems": [
          {
            "cellId": 0,
            "cellType": "LABEL_CELL",
            "label": "L+"
          },
          {
            "cellId": 1,
            "cellType": "GEL_HOLDER",
            "cellItems": []
          },
          {
            "cellId": 2,
            "cellType": "GEL_PATH",
            "cellItems": [
              {
                "gelId": 0,
                "gelType": "DRAGGABLE",
                "height": 80,
                "opacity": 0.8,
                "value": 250,
                "selected": false
              },
              {
                "gelId": 0,
                "gelType": "DRAGGABLE",
                "height": 80,
                "opacity": 0.5,
                "value": 150,
                "selected": false
              },
              {
                "gelId": 1,
                "gelType": "DRAGGABLE",
                "height": 80,
                "opacity": 0.5,
                "value": 90,
                "selected": false
              },
              {
                "gelId": 2,
                "gelType": "DRAGGABLE",
                "height": 80,
                "opacity": 0.2,
                "value": 80,
                "selected": false
              }
            ]
          }
        ]
      },

    },


    level1: {
      '100 bp DNA marker (M)': {
        "colId": index,
        "colType": "LADDER_COLUMN",
        "colItems": [
          {
            "cellId": 0,
            "cellType": "LABEL_CELL",
            "label": "DNA ladder"
          },
          {
            "cellId": 1,
            "cellType": "GEL_HOLDER",
            "cellItems": []
          },
          {
            "cellId": 2,
            "cellType": "GEL_PATH",
            "cellItems": [
              {
                "gelId": 0,
                "gelType": "FIXED",
                "height": 100,
                "opacity": 0.9,
                "value": 1000,
                "selected": false
              },
              {
                "gelId": 1,
                "gelType": "FIXED",
                "height": 60,
                "opacity": 0.8,
                "value": 800,
                "selected": false
              },
              {
                "gelId": 2,
                "gelType": "FIXED",
                "height": 60,
                "opacity": 0.5,
                "value": 700,
                "selected": false
              },
              {
                "gelId": 3,
                "gelType": "FIXED",
                "height": 100,
                "opacity": 0.9,
                "value": 500,
                "selected": false
              },
              {
                "gelId": 4,
                "gelType": "FIXED",
                "height": 60,
                "opacity": 0.5,
                "value": 400,
                "selected": false
              },
              {
                "gelId": 5,
                "gelType": "FIXED",
                "height": 60,
                "opacity": 0.4,
                "value": 300,
                "selected": false
              },
              {
                "gelId": 6,
                "gelType": "FIXED",
                "height": 60,
                "opacity": 0.4,
                "value": 200,
                "selected": false
              },
              {
                "gelId": 7,
                "gelType": "FIXED",
                "height": 60,
                "opacity": 0.3,
                "value": 100,
                "selected": false
              }
            ]
          }
        ]
      },
      "PCR product": {
        "colId": index,
        "colType": "BAND_COLUMN",
        "colItems": [
          {
            "cellId": 0,
            "cellType": "LABEL_CELL",
            "label": "PCR product"
          },
          {
            "cellId": 1,
            "cellType": "GEL_HOLDER",
            "cellItems": []
          },
          {
            "cellId": 2,
            "cellType": "GEL_PATH",
            "cellItems": [
              {
                "gelId": 0,
                "gelType": "DRAGGABLE",
                "height": 100,
                "opacity": 1,
                "value": 250,
                "selected": false
              },
              {
                "gelId": 0,
                "gelType": "DRAGGABLE",
                "height": 80,
                "opacity": 0.2,
                "value": 80,
                "selected": false
              }
            ]
          }
        ]
      }
    }
  }



  return data[level][solutionAlias] || {
    "colId": index,
    "colType": "BAND_COLUMN",
    "colItems": [
      {
        "cellId": 0,
        "cellType": "LABEL_CELL",
        "label": ""
      },
      {
        "cellId": 1,
        "cellType": "GEL_HOLDER",
        "cellItems": []
      },
      {
        "cellId": 2,
        "cellType": "GEL_PATH",
        "cellItems": []
      }
    ]
  }
}

